import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsDefined, IsOptional, IsString, IsUrl, MaxLength, ValidateNested } from 'class-validator';
import { OpenCollapseModifierGroupEnum, RecommendedItemSizeEnum, RecommendedWrapVariantEnum, StoreItemVariantDesktopEnum, StoreItemVariantMobileEnum, WebStoreExposeGroup, } from '../interface';
import { PatchFaviconDto } from './PatchFaviconDto';
import { PatchWebStoreMetadataCustomMessagesDto } from './PatchWebStoreMetadataCustomMessagesDto';
import { PatchWebStoreMetadataFooterDto } from './PatchWebStoreMetadataFooterDto';
import { PatchWebStoreMetadataThemeDto } from './PatchWebStoreMetadataThemeDto';
export class PatchWebStoreMetadataDto {
    constructor() {
        this.hideDesktopMenuItemImage = false;
        this.hideMobileMenuItemImage = false;
        this.hideInfoIcon = false;
        this.showPreviousOrders = true;
        this.showASAPOrderPreptime = false;
        this.showOrderReminder = false;
        this.homeButtonText = 'HOME';
        this.serviceOptionsPageTitle = 'Packing Instructions';
        this.previousOrdersPageTitle = 'Previous Orders';
        this.deliveryInstructionsTitle = 'Apt/Suite&additional instructions';
        this.deliveryInstructionsPlaceholder = 'Enter apartment number, suite number and additional instruction (250 characters)';
        this.taxTitle = 'Tax';
        this.showZeroDeliveryFee = false;
        this.topSellingItemsTitle = 'Top Selling Items';
        this.showOrderNotes = false;
        this.showDelayedPaymentDisclaimer = false;
        this.isCurbsidePickupEnabled = false;
        this.curbsidePickupOrderNotesTitle = 'Notes';
        this.orderConfirmationPageTitle = 'Order Confirmation';
        this.editUserModalTitle = 'Personal info';
        this.curbsidePickupOrderNotesPlaceholder = 'Max 320 characters';
        this.showAsapInfoMessage = false;
        this.forceShowAsapInfoMessage = false;
        this.hideDelayedOrderTime = false;
        this.hidePromotionBar = false;
        this.menu = {
            showTextGradient: false,
        };
        this.storeItem = {
            showZeroPrice: false,
            showTextGradient: false,
            variant: { desktop: StoreItemVariantDesktopEnum.THUMBNAIL_TOP, mobile: StoreItemVariantMobileEnum.LEGACY },
        };
        this.topCategories = {
            showTextGradient: false,
        };
        this.modifiers = {
            showZeroPrice: false,
            openCollapseModifierGroup: OpenCollapseModifierGroupEnum.ALL,
        };
        this.navigation = {
            hide: false,
        };
        this.footer = new PatchWebStoreMetadataFooterDto();
        this.favicon = new PatchFaviconDto();
        this.theme = new PatchWebStoreMetadataThemeDto();
        this.itemModalConfig = {
            mobile: {
                hasModifiers: {
                    image: false,
                    description: false,
                    ingredients: false,
                },
                noModifiers: {
                    image: true,
                    description: false,
                    ingredients: false,
                },
            },
            desktop: {
                hasModifiers: {
                    image: false,
                    description: false,
                    ingredients: false,
                },
                noModifiers: {
                    image: true,
                    description: false,
                    ingredients: false,
                },
            },
        };
        this.customMessages = new PatchWebStoreMetadataCustomMessagesDto();
        this.orderToTable = {
            title: 'Order to table',
            componentsOrder: 'text badge',
            subtext: 'We’ll bring your order when it’s ready.',
            text: 'Table Number',
        };
        this.recommendedItems = {
            title: 'Recommended Items',
            subtitle: 'Complete your order with our customer favorites!',
            mobileVariant: RecommendedWrapVariantEnum.SINGLE_ITEM_ROW,
            variant: RecommendedWrapVariantEnum.SINGLE_ITEM_ROW,
            size: RecommendedItemSizeEnum.MEDIUM,
            mobileSize: RecommendedItemSizeEnum.MEDIUM,
        };
        this.scheduleBlock = {
            text: 'Pre-Order Only. Check item details for more info',
            itemText: 'Pre-Order Only. Check item details for more info',
            itemModalText: 'Pre-Order Only.',
        };
        this.navigationBar = {
            shown: false,
        };
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "homeButtonUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "headerLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUrl({ require_protocol: true, require_host: true, require_valid_protocol: true }, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "additionalLogo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "gTag", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "gTags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "hideDesktopMenuItemImage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "hideMobileMenuItemImage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "hideInfoIcon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "messangerLink", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "cartIcon", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "itemOptionSortStrategy", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showPreviousOrders", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showASAPOrderPreptime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showOrderReminder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "toastUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "receiveMethodTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "facebookPixel", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    MaxLength(250, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "facebookAccessToken", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    MaxLength(50, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "facebookTestCode", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "homeButtonText", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "serviceOptionsPageTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "previousOrdersPageTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "deliveryInstructionsTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "deliveryInstructionsPlaceholder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "taxTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showZeroDeliveryFee", void 0);
__decorate([
    ApiPropertyOptional({ type: String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "topSellingItemsTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showOrderNotes", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showDelayedPaymentDisclaimer", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "isCurbsidePickupEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "curbsidePickupOrderNotesTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "orderConfirmationPageTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "editUserModalTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "curbsidePickupOrderNotesPlaceholder", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "showAsapInfoMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsBoolean({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "forceShowAsapInfoMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: Boolean }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "hideDelayedOrderTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: false }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PatchWebStoreMetadataDto.prototype, "hidePromotionBar", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "menu", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "storeItem", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "topCategories", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "modifiers", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "navigation", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchWebStoreMetadataFooterDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ groups: [WebStoreExposeGroup.UPDATE] }),
    ValidateNested({ always: true }),
    Type(() => PatchWebStoreMetadataFooterDto),
    IsUndefinable({ groups: [WebStoreExposeGroup.CREATE, WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", PatchWebStoreMetadataFooterDto)
], PatchWebStoreMetadataDto.prototype, "footer", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchFaviconDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => PatchFaviconDto),
    __metadata("design:type", PatchFaviconDto)
], PatchWebStoreMetadataDto.prototype, "favicon", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchWebStoreMetadataThemeDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => PatchWebStoreMetadataThemeDto),
    __metadata("design:type", PatchWebStoreMetadataThemeDto)
], PatchWebStoreMetadataDto.prototype, "theme", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "itemModalConfig", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "heroBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "receiveMethodPage", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "disclaimers", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "webstoreAddress", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "promotionNotification", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "cartPromotion", void 0);
__decorate([
    ApiPropertyOptional({ type: PatchWebStoreMetadataCustomMessagesDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    ValidateNested({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    Type(() => PatchWebStoreMetadataCustomMessagesDto),
    __metadata("design:type", PatchWebStoreMetadataCustomMessagesDto)
], PatchWebStoreMetadataDto.prototype, "customMessages", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "customHeaderButton", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "cartButton", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "headerLogoUrl", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "orderComplete", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "headerTopNavBar", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "iframeLoyalty", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "metaTags", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "unsubscribeMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "defaultTip", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "socialMedia", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "orderToTable", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "recommendedItems", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "prepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "scheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "menuConcepts", void 0);
__decorate([
    ApiPropertyOptional({ type: Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], PatchWebStoreMetadataDto.prototype, "navigationBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PatchWebStoreMetadataDto.prototype, "defaultCartImage", void 0);
//# sourceMappingURL=PatchWebStoreMetadataDto.js.map